import _Abstract from "system/abstract"
export default class Component_InputValidator extends _Abstract {

  constructor(el, options) {
    super(el, $.extend(true, {
    }, options), 'component')
		console.log("INPUT VALIDATOR");
    this.EMAIL_REGULAR_EXPRESSION = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    
    this.bindEvents()
  }

	bindEvents()
	{
		this.$el.find("input").blur((e) => this.onInputBlurred(e));
    this.$el.find("input").keyup((e) => this.onInputKeyUp(e));
    // this.$el.find(" input").keydown((e) => this.onInputKeyDown(e));

		if(typeof this.options.submit_button_selector !== "undefined")
		{
			this.$el.find(this.options.submit_button_selector).click((e) => this.onSubmitButtonClicked(e));
		}

	}


	onInputBlurred(e)
	{
		var $input = $(e.currentTarget);
		this.validateElement($input);
	}

  onInputKeyDown(e)
  {
    var $input = $(e.currentTarget);
    return this.forceCharacterLimits($input);
  }

	onInputKeyUp(e)
	{
		var $input = $(e.currentTarget);
    this.validateElement($input);
	}

  forceCharacterLimits($element)
  {
    var characterLimit = $element.data("character-limit");
    if(!characterLimit)
    {
      return true;
    }

    var elementValue = $element.val();
    if(elementValue.length > characterLimit)
    {
      return false;
    }
    return true;
  }


  	validateElement($element)
  	{

      if(!$element.closest(".c-label-input-ctn").hasClass("required"))
      {
        return;
      }

      var inputType = $element.attr("type");
      var bValidInput = $element.val();
      if(inputType.toLowerCase() === "email")
      {
        bValidInput = this.EMAIL_REGULAR_EXPRESSION.test($element.val());
      }

			if($element.data("match"))
			{
				var matchSelector = $element.data("match");
				var $elementToMatch = $(matchSelector);
				if($elementToMatch.length)
				{
					if($element.val() !== $elementToMatch.val())
					{
						bValidInput = false;
					}
				}
				else
				{
					console.log("input-validator: Failed to find matching element to compare data!");
				}


			}


	  	if(bValidInput)
	  	{
	  		$element.removeClass("invalid-input");
				$element.closest(".c-label-input-ctn").removeClass("invalid-input");
	  		return true;
	  	}
	  	else
	  	{
	  		$element.addClass("invalid-input");
				$element.closest(".c-label-input-ctn").addClass("invalid-input");
	  		return false;
	  	}
  	}

  	onSubmitButtonClicked(e)
  	{
  		var context = this;
  		var bAllValidated = true;
  		this.$el.find(".required input").each(function()
  		{
  			var $input = $(this);
  			if(!context.validateElement($input))
  			{
  				bAllValidated = false;
  			}
  		});

  		if(bAllValidated)
  		{
  			this.$el.find(".form-is-valid").removeClass('-hide');
  			this.$el.find(".form-is-invalid").addClass('-hide');
  		}
  		else
  		{
  			this.$el.find(".form-is-valid").addClass('-hide');
  			this.$el.find(".form-is-invalid").removeClass('-hide');
  			e.preventDefault();
  			e.stopImmediatePropagation();

  		}

  	}

}



/** WEBPACK FOOTER **
 ** ./components/input-validator.js
 **/